export default __webpack_public_path__ + "static/media/generalAccountDetails.ab87e1e0.svg";